export default {
  // 标签页
  otcTrading: "OTC交易",
  depositWithdrawTrading: "充提交易",
  userBehavior: "用户行为",
  accountBalance: "账户余额",
  walletBalance: "钱包余额",
  loginDeviceInfo: "登录/设备信息",
  deliveryInfo: "收货信息",
  paymentMethodRecord: "收款方式记录",

  // 消息提示
  alreadyCurrentPage: "已经是当前详情页!",
};
